module.exports = __webpack_public_path__ + "img/Truppführer_Sanitätstrupp.c00db99a.svg";